import { render, staticRenderFns } from "./serviceBox.vue?vue&type=template&id=31d79864&scoped=true"
import script from "./serviceBox.vue?vue&type=script&lang=js"
export * from "./serviceBox.vue?vue&type=script&lang=js"
import style0 from "./serviceBox.vue?vue&type=style&index=0&id=31d79864&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d79864",
  null
  
)

export default component.exports